import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { IUiNotificationService } from 'src/app/interfaces';
import { UiNotificationType } from 'src/app/models';
import { GetTokenUseCase } from 'src/app/use-cases';

@Component({
  selector: 'app-tableau',
  templateUrl: './tableau.component.html',
  styleUrls: ['./tableau.component.scss']
})
export class TableauComponent implements OnInit{
  token ="";
  srcUrl="";
  isLoading = true;
  contentHeight = 0;

  constructor(
    private router: Router,
    private getTokenUseCase: GetTokenUseCase,
    @Inject('IUiNotificationService') private uiNotificationService: IUiNotificationService) { }
  
  ngOnInit(): void {
    this.srcUrl = history.state.tableauUrl;
    this.getToken();
    this.calculateHeight();
  }

  @HostListener('window:resize')
  onResize(){
    this.calculateHeight();
  }

  getToken() {
    this.isLoading = true;

    this.getTokenUseCase.execute()
      .pipe(finalize(() => {
        this.isLoading = false;
        setTimeout(()=>{
          this.checkTableauViz();
        }, 3000)
        
      }))
      .subscribe({
        next: (response: string) => {
          this.token = response;
          // console.log(this.token);
          
        }
      });
  }

  checkTableauViz()
  {
     if(document.querySelector("body")?.querySelector('tableau-viz')?.shadowRoot?.querySelector('iframe')?.contentDocument != null)
     {
      this.uiNotificationService.showNotification(
        UiNotificationType.Warning,
        "No access to tableau reports");
        this.router.navigate(['/unauthorized']);
     }
  }

  calculateHeight() {
    const headerHeight = 40;
    const footerHeight = 20;
    // console.log(window.innerHeight);
    if(window.innerHeight > 570){
    this.contentHeight = window.innerHeight - headerHeight - footerHeight;
    }
    else{
      this.contentHeight = 570;
    }
  }
}


